<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="3" lg="4">
          <v-select v-model="filter.facilityId"
            :items="facilitiesSelect"
            item-text="name"
            item-value="id"
            outlined
            dense
            :label="$t('label.facility')">
          </v-select>
        </v-col>
        <v-col cols="3" lg="4">
          <v-text-field v-model="filter.invoice" dense :label="$t('label.shipmentDoc')" outlined clearable></v-text-field>
        </v-col>
        <v-col cols="3" lg="4">
          <v-select v-model="filter.printStatusId"
            :items="printStatus"
            item-text="name"
            item-value="value"
            outlined
            dense
            :label="$t('label.printStatus')">
          </v-select>
        </v-col>
        <v-col cols="3" lg="4">
          <v-select
            v-model="filter.asnStatusId"
            :items="asnStatus"
            item-text="name"
            item-value="value"
            outlined
            dense
            :label="$t('label.asnStatus')"
            >
          </v-select>
        </v-col>
        <v-col cols="3" lg="4">
          <v-text-field
            v-model="filter.shipmentId"
            dense
            outlined
            :rules="[rules.number]"
            :label="$t('label.shipId')"
            >
          </v-text-field>
        </v-col>
        <v-col cols="3" lg="3">
          <v-btn depressed color="primary" @click="getVendorShipmentsPending(true)" :loading="isLoading">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-data-table
        v-if="showTable"
        :headers="headers"
        :items="shipments"
        :loading="isLoading"
        :options.sync="options"
        :items-per-page="filter.itemsPerPage"
        :footer-props="footerProps"
        :server-items-length="totalOfItems"
      >
        <template v-slot:[`item.instruction`]="{ item }">
          <span :title="item.instruction">{{ cutText(item.instruction, 50) }}</span>
        </template>
        <template v-slot:[`item.vendorCode`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{ item.vendorCode }} - {{ cutText(item.vendorName || '', 15) }}</span>
            </template>
            <span>{{ item.vendorName }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.creationDateFormated`]="{ item }">
          {{ item.creationDateFormated ? item.creationDateFormated.split(' ')[0] : '' }}
        </template>
        <template v-slot:[`item.options`]="{ item }">
          <v-btn class="btn-action" v-if="item.isConsignment" :disabled="item.hasCustomDistribution || item.shipmentStatus === 2" icon :title="getPrintTooltip(item.printStatus)" small depressed @click.stop="downloadLabelConsigment(item)">
            <v-icon :color="item.printStatus === 2 ? 'success' : 'error'">mdi-printer</v-icon>
          </v-btn>
          <v-btn class="btn-action" v-if="!item.isConsignment" :disabled="item.hasCustomDistribution || item.shipmentStatus === 2" icon :title="getPrintTooltip(item.printStatus)" small depressed @click.stop="downloadLabel(item)">
            <v-icon :color="item.printStatus === 2 ? 'success' : 'error'">mdi-printer</v-icon>
          </v-btn>
          <v-btn :disabled="item.shipmentStatus === 2" icon class="btn-action" color="primary" :title="getAsnTooltip(item.shipmentStatus)" small depressed @click.stop="openAsnDialog(item)">
            <v-icon :color="item.shipmentStatus === 2 ? 'success' : 'error'">mdi-truck-delivery</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.firstOptions`]="{ item }">
          <v-btn v-if="item.isBlocked" class="btn-action" icon :title="$t('label.shipmentBlocked')" small depressed @click.stop="openShipmentBlockedDialog(item)">
            <v-icon color="error">mdi-exclamation-thick</v-icon>
          </v-btn>
          <v-btn class="btn-action" icon :title="$t('label.details')" small depressed @click.stop="selectShipment(item, 'detail')">
            <v-icon color="primary">mdi-file-document</v-icon>
          </v-btn>
          <v-btn :disabled="item.shipmentStatus === 2 || item.isBlocked === 1" icon color="warning" class="btn-action" :title="$t('label.cancel')" small depressed @click.stop="openCancelShipmentDialog(item)">
            <v-icon>mdi-cancel</v-icon>
          </v-btn>
        </template>
        <!-- <template v-slot:[`item.isConsignment`]="{ item }">
          <v-icon v-if="item.isConsignment" color="success">mdi-check</v-icon>
          <v-icon v-else color="error">mdi-close</v-icon>
        </template> -->
        <template v-slot:[`item.virtualReceptionStatus`]="{ item }">
          <v-chip v-if="item.isVirtualReception" :color="getVirtualReceptionStatusColor(item.virtualReceptionStatus)" label small>
            {{ getVirtualReceptionStatusName(item.virtualReceptionStatus) }}
          </v-chip>
        </template>
        <template v-slot:[`item.incidentStatus`]="{ item }">
          <v-chip v-if="item.incidentStatus" :color="getIncidentStatusColor(item.incidentStatus)" text-color="white" label small style="cursor: pointer" @click.stop="showIncident(item)">
            <v-icon left small>mdi-alert-octagram</v-icon>
            {{ getIncidentStatusName(item.incidentStatus) }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog v-model="isIncidentDetailOpen" max-width="720" scrollable>
      <incident-detail-card :incidentId="selectedIncidentId" @close="isIncidentDetailOpen = false"/>
    </v-dialog>
    <v-dialog v-model="isAsnDialogOpen" persistent width="600">
      <v-card>
        <v-form ref="asnForm" v-model="isFormValid">
          <v-card-title>
            <h3>{{ $t('label.createASN') }}</h3>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" v-show="invoiceExists">
                <h4>{{ $t('message.info.existingInvoice') }}</h4>
              </v-col>
              <v-col cols="12">
                <v-text-field :label="$t('label.invoice')" v-model="shipmentSelected.invoice" @change="checkInvoice"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field :label="$t('label.instruction')" v-model="shipmentSelected.instruction"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field :label="$t('label.trackingNumber')" v-model="shipmentSelected.trackingNumber"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small depressed @click.stop="isAsnDialogOpen = false" :disabled="isLoading">{{ $t('label.close') }}</v-btn>
            <v-btn small depressed  color="primary" :disabled="isLoading || invoiceExists" @click.stop="isCreateAsnConfirmationDialogOpen = true">{{ $t('label.save') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isCreateAsnConfirmationDialogOpen" persistent width="500">
      <confirmation-dialog @confirm="confirmAscCreation">{{ $t('message.confirmation.createAsn') }}</confirmation-dialog>
    </v-dialog>
    <v-dialog v-model="isCancelShipmentConfirmationDialogOpen" persistent width="500">
      <confirmation-dialog @confirm="confirmShipmentCancel">{{ $t('message.confirmation.cancelShipment') }}</confirmation-dialog>
    </v-dialog>
    <v-dialog v-model="isReplaceFilesConfirmationDialogOpen" persistent width="500">
      <confirmation-dialog @confirm="confirmReplace">{{ $t('message.confirmation.filesAlreadyExist', [fileNamesFound.join(', ')]) }}</confirmation-dialog>
    </v-dialog>
    <v-dialog v-model="isShipmentBlockedDialogOpen" persistent width="500">
      <v-card>
        <v-card-title>
          <h3>{{ $t('label.shipmentBlocked') }}</h3>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h4>{{ $t('message.info.shipmentBlocked') }}
                <br>
                <a @click="isShipmentBlockedDialogOpen = false;selectShipment(shipmentSelected, 'detail')">{{ $t('label.viewDetails') }}</a>
              </h4>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small depressed @click.stop="isShipmentBlockedDialogOpen = false" :disabled="isLoading">{{ $t('label.close') }}</v-btn>
          <!-- <v-btn small depressed  color="error" :disabled="isLoading" @click.stop="isShipmentBlockedDialogOpen = false;isCancelShipmentConfirmationDialogOpen = true">{{ $t('label.cancelShipment') }}</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isUploadInvoiceDialogOpen" persistent scrollable width="800">
      <v-card>
        <v-card-title>
          {{ uploadedInvoicesTitle }}
          <v-chip class="ml-2" :color="getInvoiceStatusColor(selectedInvoiceStatus)">
            {{ getInvoiceStatusName(selectedInvoiceStatus) }}
          </v-chip>
          <v-spacer>
          </v-spacer>
          <v-btn
            color="primary"
            @click.stop="openInputFile()"
            :loading="loading.invoices"
            >
            {{ $t('label.uploadInvoice') }}
            <v-icon right>
              mdi-cloud-upload
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="height: 500px">
          <v-data-table
            :loading="loading.invoices"
            :items="invoices"
            :headers="invoiceHeaders"
            hide-default-footer
            >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{ $t('label.currentInvoice') }}</v-toolbar-title>
                <v-spacer>
                </v-spacer>
                <form ref="inputFileForm">
                  <input
                    type="file"
                    ref="inputFile"
                    multiple
                    accept="application/pdf,application/xml"
                    style="display:none"
                    @change="previewFiles">
                </form>
              </v-toolbar>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <v-row>
                <v-icon
                  v-if="item.fileExtension === 1"
                  class="mr-2"
                  color="red">
                  mdi-file-pdf-box
                </v-icon>
                <v-icon
                  v-if="item.fileExtension === 2"
                  class="mr-2"
                  color="blue"
                  >
                  mdi-xml
                </v-icon>
                <span>{{ item.name }}</span>
              </v-row>
            </template>
            <template v-slot:[`item.options`]="{ item }">
              <a :href="downloadUrl + item.id" style="text-decoration:none">
                <v-btn class="btn-action" icon :title="$t('label.download')" small depressed>
                  <v-icon color="primary">mdi-cloud-download</v-icon>
                </v-btn>
              </a>
            </template>
          </v-data-table>
          <v-data-table
            :loading="loading.invoices"
            :items="history"
            :headers="invoiceHistoryHeaders"
            >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{ $t('label.historicInvoices') }}</v-toolbar-title>
                <v-spacer>
                </v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <v-row>
                <v-icon
                  v-if="item.fileExtension === 1"
                  class="mr-2"
                  color="red">
                  mdi-file-pdf-box
                </v-icon>
                <v-icon
                  v-if="item.fileExtension === 2"
                  class="mr-2"
                  color="blue"
                  >
                  mdi-xml
                </v-icon>
                <span>{{ item.name }}</span>
              </v-row>
            </template>
            <template v-slot:[`item.options`]="{ item }">
              <a :href="downloadUrl + item.id" style="text-decoration:none">
                <v-btn class="btn-action" icon :title="$t('label.download')" small depressed>
                  <v-icon color="primary">mdi-cloud-download</v-icon>
                </v-btn>
              </a>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer>
          </v-spacer>
          <v-btn small depressed @click.stop="isUploadInvoiceDialogOpen = false">
            {{ $t('label.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { loading, showMessage, rules } from '../../../mixins'
import { cutText } from '../../../core/sharedFunctions'
import ConfirmationDialog from '../../Shared/ConfirmationDialog.vue'
import IncidentDetailCard from '../incidents/IncidentDetailCard.vue'
import { saveAs } from 'file-saver'

export default {
  name: 'PendingShipmentsList',
  props: {
    print: {
      type: Boolean,
      default: false
    },
    pendings: {
      type: Boolean,
      default: false
    }
  },
  components: { ConfirmationDialog, IncidentDetailCard },
  mixins: [loading, showMessage, rules],
  data: () => ({
    downloadUrl: `${process.env.VUE_APP_API_URL}/api/shipments/download-invoice/`,
    invoiceDownloadUrl: `${process.env.VUE_APP_API_URL}/api/shipments/incident/`,
    facilities: [],
    shipments: [],
    invoices: [],
    history: [],
    selectedInvoiceStatus: 0,
    fileNamesFound: [],
    selectedFiles: [],
    totalOfItems: 0,
    filter: {
      facilityId: 0,
      invoice: '',
      printStatusId: 0,
      asnStatusId: -1,
      shipmentId: '',
      page: 1,
      itemsPerPage: 30
      // invoiceStatusId: -1
    },
    options: {
      sortBy: ['tentativeDeliveryDate'],
      sortDesc: [true],
      itemsPerPage: 10
    },
    showTable: false,
    loading: {
      facilities: false,
      invoices: false
    },
    uploadedInvoicesTitle: '',
    selectedShipment: null,
    isAsnDialogOpen: false,
    isFormValid: true,
    invoiceExists: false,
    invoiceChecked: false,
    shipmentSelected: {
      shipmentId: 0
    },
    isCreateAsnConfirmationDialogOpen: false,
    isCancelShipmentConfirmationDialogOpen: false,
    isShipmentBlockedDialogOpen: false,
    isUploadInvoiceDialogOpen: false,
    isReplaceFilesConfirmationDialogOpen: false,
    isIncidentDetailOpen: false,
    selectedIncidentId: null,
    footerProps: {
      'items-per-page-options': [5, 10, 15, 30, 100]
    }
  }),
  computed: {
    facilitiesSelect () {
      return [{ id: 0, name: this.$t('label.all') }, ...this.facilities]
    },
    headers () {
      const headers = [
        { text: this.$t('label.actions'), value: 'firstOptions', align: 'center', sortable: false, filterable: false, width: '150' },
        { text: this.$t('label.shipId'), value: 'shipmentId', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.vendor'), value: 'vendorCode', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.creationDate'), value: 'creationDateFormated', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.invoiceDoc'), value: 'invoice', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.facility'), value: 'facilityName', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.quantityToShip'), value: 'totalQuantity', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.receivedQuantity'), value: 'confirmedQuantity', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.incidentStatus'), value: 'incidentStatus', align: 'center', sortable: true, filterable: true },
        ...(this.hasVirtualReception ? [{ text: this.$t('label.virtualReceptionStatus'), value: 'virtualReceptionStatus', align: 'center', sortable: true, filterable: true }] : []),
        { text: this.$t('label.process'), value: 'options', align: 'center', sortable: false, filterable: false, width: '100' }
      ]
      return headers
    },
    invoiceHeaders () {
      return [
        { text: 'File name', value: 'name', align: 'center', sortable: false, filterable: true },
        { text: 'Upload date', value: 'uploadDateFormated', align: 'center', sortable: false, filterable: true },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: true }
      ]
    },
    invoiceHistoryHeaders () {
      return [
        { text: 'File name', value: 'name', align: 'center', sortable: false, filterable: true },
        { text: 'Upload date', value: 'uploadDateFormated', align: 'center', sortable: false, filterable: true },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: false }
      ]
    },
    printStatus () {
      const printStatus = [
        { name: this.$t('label.all'), value: 0 },
        { name: this.$t('label.printed'), value: 2 },
        { name: this.$t('label.unprinted'), value: 1 }
      ]

      return printStatus
    },
    hasVirtualReception () {
      return this.shipments.some(s => s.isVirtualReception)
    },
    asnStatus () {
      const asnStatus = [
        { name: this.$t('label.all'), value: -1 },
        { name: this.$t('label.asnSent'), value: 1 },
        { name: this.$t('label.asnUnsent'), value: 0 }
      ]
      return asnStatus
    }
    // invoiceStatus () {
    //   const invoiceStatus = [
    //     { name: this.$t('label.all'), value: -1 },
    //     { name: this.$t('label.pendingUpload'), value: 0 },
    //     { name: this.$t('label.new'), value: 1 },
    //     { name: this.$t('label.received'), value: 2 },
    //     { name: this.$t('label.enteredInvoice'), value: 3 },
    //     { name: this.$t('label.paymentProcess'), value: 4 },
    //     { name: this.$t('label.error'), value: 20 }
    //   ]
    //   return invoiceStatus
    // }
  },
  methods: {
    getPrintTooltip (statusId) {
      switch (statusId) {
        case 2:
          return this.$t('label.printed')
        default:
          return this.$t('label.pendingPrint')
      }
    },
    getAsnTooltip (statusId) {
      switch (statusId) {
        case 2:
          return this.$t('label.asnSent')
        default:
          return this.$t('label.pendingAsn')
      }
    },
    getInvoiceStatusName (statusId) {
      switch (statusId) {
        case 0:
          return this.$t('label.pendingUpload')
        case 1:
          return this.$t('label.new')
        case 2:
          return this.$t('label.received')
        case 3:
          return this.$t('label.enteredInvoice')
        case 4:
          return this.$t('label.paymentProcess')
        case 20:
          return this.$t('label.error')
      }
    },
    getInvoiceStatusColor (statusId) {
      switch (statusId) {
        case 0:
          return 'gray'
        case 1:
          return 'success'
        case 2:
          return 'yellow'
        case 3:
          return 'yellow'
        case 4:
          return 'yellow'
        case 20:
          return 'yellow'
      }
    },
    showIncident (item) {
      this.selectedIncidentId = item.incidentId
      this.isIncidentDetailOpen = true
    },
    getIncidentStatusName (statusId) {
      switch (statusId) {
        case 1:
          return 'Open'
        case 2:
          return 'Resolved'
        case 3:
          return 'Cancelled'
      }
    },
    getIncidentStatusColor (statusId) {
      switch (statusId) {
        case 1:
          return 'error'
        case 2:
          return 'success'
        case 3:
          return 'grey'
      }
    },
    getVirtualReceptionStatusName (statusId) {
      switch (true) {
        case statusId === 0:
          return this.$t('label.notProcessed')
        case statusId >= 1:
          return this.$t('label.processed')
        default:
          return statusId
      }
    },
    getVirtualReceptionStatusColor (statusId) {
      switch (true) {
        case statusId === 0:
          return 'warning'
        case statusId >= 1:
          return 'success'
        default:
          return 'gray'
      }
    },
    downloadInvoice (item) {
      this.downloadEndpoint = `${process.env.VUE_APP_API_URL}/api/shipments/download-invoice/${item.id}`
      // this.$refs.downloadLink.click()
      // this.loading.invoices = true
      // this.$proxy.get(`api/shipments/download-invoice/${item.id}`)
      //   .then(res => {
      //     console.log(res)
      //     // saveAs(res.data, item.fileName)
      //     this.showMessage('Descargado correctamente.', item.fileName)
      //   })
      //   .catch(e => {
      //     this.showHttpErrorMessage(e)
      //   })
      //   .finally(_ => {
      //     this.loading.invoices = false
      //   })
    },
    openUploadInvoiceDialog (item) {
      // this.selectedShipment = Object.assign({}, item)
      this.selectedShipment = item
      this.uploadedInvoicesTitle = `${this.$t('label.shipId')} ${this.selectedShipment.shipmentId}`
      this.isUploadInvoiceDialogOpen = true
      this.getUploadedInvoices()
    },
    openInputFile () {
      this.$refs.inputFile.click()
    },
    async confirmReplace (confirm) {
      if (confirm) {
        await this.uploadAndReplace()
      } else {
        this.$refs.inputFileForm.reset()
      }
      this.isReplaceFilesConfirmationDialogOpen = false
    },
    async uploadAndReplace () {
      const formData = new FormData()
      for (let i = 0; i < this.selectedFiles.length; i++) {
        formData.append('files', this.selectedFiles[i])
      }
      this.loading.invoices = true
      try {
        await this.$proxy.post(`api/shipments/${this.selectedShipment.shipmentId}/invoice-replace`, formData)
        await this.getUploadedInvoices()
        this.showMessage('Cargado correctamente.')
      } catch (e) {
        this.showHttpErrorMessage(e)
      } finally {
        this.loading.invoices = false
        this.$refs.inputFileForm.reset()
      }
    },
    async previewFiles () {
      const files = this.$refs.inputFile.files
      if (files.length === 0) {
        return
      }

      const fileNames = []
      this.selectedFiles = []
      const formData = new FormData()
      for (let i = 0; i < files.length; i++) {
        fileNames.push(files[i].name)
        this.selectedFiles.push(files[i])
        formData.append('files', files[i])
      }

      this.loading.invoices = true
      try {
        const response = await this.$proxy.post(`api/shipments/verify-files/${this.selectedShipment.shipmentId}`, fileNames)
        this.fileNamesFound = response.data
        if (this.fileNamesFound.length === 0) {
          await this.$proxy.post(`api/shipments/${this.selectedShipment.shipmentId}/invoice`, formData)
          await this.getUploadedInvoices()
          this.showMessage('Cargado correctamente.')
        } else {
          this.isReplaceFilesConfirmationDialogOpen = true
        }
      } catch (e) {
        this.showHttpErrorMessage(e)
      } finally {
        this.loading.invoices = false
        this.$refs.inputFileForm.reset()
      }

      // this.$proxy.post(`api/shipments/verify-files/${this.selectedShipment.shipmentId}`, { fileNames })
      //   .then(res => {
      //     this.fileNamesFound = res.data
      //     if (this.fileNamesFound.length === 0) {
      //       this.$proxy.post(`api/shipments/${this.selectedShipment.shipmentId}/invoice`, formData)
      //         .then(_ => {
      //           this.getUploadedInvoices()
      //           this.showMessage('Cargado correctamente.')
      //         })
      //         .catch(e => {
      //           this.showHttpErrorMessage(e)
      //         })
      //     }
      //   })
      //   .catch(e => {
      //     this.showHttpErrorMessage(e)
      //   })
      //   .finally(_ => {
      //     this.loading.invoices = false
      //   })

      // this.loading.invoices = true
      // this.$proxy.post(`api/shipments/${this.selectedShipment.shipmentId}/invoice`, formData)
      //   .then(_ => {
      //     this.getUploadedInvoices()
      //     this.showMessage('Cargado correctamente.')
      //   })
      //   .catch(e => {
      //     this.showHttpErrorMessage(e)
      //   })
      //   .finally(_ => {
      //     this.loading.invoices = false
      //   })
    },
    async getUploadedInvoices () {
      this.loading.invoices = true
      try {
        const res = await this.$proxy.get(`api/shipments/${this.selectedShipment.shipmentId}/invoice`)
        this.invoices = res.data.current
        this.history = res.data.history
        this.selectedInvoiceStatus = res.data.invoiceStatus
        this.selectedShipment.invoiceStatus = this.selectedInvoiceStatus
      } catch (e) {
        this.showHttpErrorMessage(e)
      } finally {
        this.loading.invoices = false
      }
    },
    getFacilities () {
      this.loading.facilities = true
      this.$proxy.get('api/edi/facilities')
        .then((r) => {
          this.facilities = r.data
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.loading.facilities = false
        })
    },
    // getShipments () {
    //   this.getVendorShipmentsPending()
    // },
    // getVendorShipments () {
    //   this.changeLoadingStatus(true)
    //   this.$proxy.get(`api/edi/shipments?printStatus=${this.filter.printStatusId}&facilityId=${this.filter.facilityId}&invoice=${this.filter.invoice}`)
    //     .then((r) => {
    //       this.shipments = r.data
    //       this.showTable = true
    //     })
    //     .catch((e) => {
    //       this.showHttpErrorMessage(e)
    //     })
    //     .finally(() => {
    //       this.changeLoadingStatus(false)
    //     })
    // },
    getVendorShipmentsPending (isInitialSearch) {
      if (isInitialSearch) {
        this.options.page = 1
        this.filter.page = 1
      }
      const params = new URLSearchParams()
      if (this.filter.invoice) {
        params.append('invoice', this.filter.invoice)
      }
      if (this.filter.facilityId && this.filter.facilityId !== 0) {
        params.append('facilityId', this.filter.facilityId)
      }
      if (this.filter.printStatusId && this.filter.printStatusId !== 0) {
        params.append('printStatus', this.filter.printStatusId)
      }
      if (this.filter.asnStatusId !== -1) {
        params.append('sentAsn', this.filter.asnStatusId === 1)
      }
      if (this.filter.shipmentId) {
        params.append('shipmentId', this.filter.shipmentId)
      }
      // if (this.filter.invoiceStatusId !== -1) {
      //   params.append('invoiceStatus', this.filter.invoiceStatusId)
      // }
      this.changeLoadingStatus(true)
      this.$proxy.get(`api/edi/shipments/pending/${this.filter.page}/${this.filter.itemsPerPage}?${params.toString()}`)
        .then((r) => {
          this.shipments = r.data.items
          this.totalOfItems = r.data.totalOfItems
          this.showTable = true
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    selectShipment (item, action) {
      this.$emit('itemSelected', item, action)
      this.getVendorShipmentsPending()
    },
    downloadLabel (item) {
      this.shipmentSelected = Object.assign({}, item)
      this.changeLoadingStatus(true)
      this.$proxy.getDownload(`api/edi/shipments/${this.shipmentSelected.shipmentId}/label`)
        .then((r) => {
          saveAs(r.data, `Shipment-${this.shipmentSelected.shipmentId}.pdf`)
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.getVendorShipmentsPending()
          this.changeLoadingStatus(false)
        })
    },
    downloadLabelConsigment (item) {
      this.shipmentSelected = Object.assign({}, item)
      this.changeLoadingStatus(true)
      this.$proxy.getDownload(`api/edi/shipments/${this.shipmentSelected.shipmentId}/labelconsignment`)
        .then((r) => {
          saveAs(r.data, `Shipment-${this.shipmentSelected.shipmentId}.pdf`)
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.getVendorShipmentsPending()
          this.changeLoadingStatus(false)
        })
    },
    downloadLabelConsignment (item) {
      this.shipmentSelected = Object.assign({}, item)
      this.changeLoadingStatus(true)
      this.$proxy.getDownload(`api/edi/shipments/${this.shipmentSelected.shipmentId}/labelConsignment`)
        .then((r) => {
          saveAs(r.data, `Shipment-${this.shipmentSelected.shipmentId}.pdf`)
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.getVendorShipmentsPending()
          this.changeLoadingStatus(false)
        })
    },
    openAsnDialog (item) {
      this.shipmentSelected = Object.assign({}, item)
      this.isAsnDialogOpen = true
      this.invoiceChecked = false
      this.invoiceExists = false
      this.checkInvoice()
    },
    openCancelShipmentDialog (item) {
      this.shipmentSelected = Object.assign({}, item)
      this.isCancelShipmentConfirmationDialogOpen = true
    },
    checkInvoice () {
      if (!this.isFormValid) {
        return
      }
      this.changeLoadingStatus(true)
      this.$proxy.get(`api/edi/shipments/${this.shipmentSelected.shipmentId}/invoice/validation?invoice=${this.shipmentSelected.invoice}`)
        .then((r) => {
          this.invoiceExists = r.data
          this.invoiceChecked = true
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
          this.invoiceExists = false
          this.invoiceChecked = false
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    confirmAscCreation (confirm) {
      this.isCreateAsnConfirmationDialogOpen = false
      if (confirm) {
        this.saveAsn()
      }
    },
    saveAsn () {
      if ((this.shipmentSelected.invoice === '' || this.shipmentSelected.invoice === null || typeof this.shipmentSelected.invoice === 'undefined') &&
          (this.shipmentSelected.instruction === '' || this.shipmentSelected.instruction === null || typeof this.shipmentSelected.instruction === 'undefined')) {
        this.showMessage(this.$t('message.error.invoiceOrInstructionRequired'))
        return
      }
      this.changeLoadingStatus(true)
      this.$proxy.post(`api/edi/shipments/${this.shipmentSelected.shipmentId}/asn?invoice=${this.shipmentSelected.invoice}&instruction=${this.shipmentSelected.instruction}&trackingNumber=${this.shipmentSelected.trackingNumber}`)
        .then((r) => {
          this.getVendorShipmentsPending()
          this.showMessage(this.$t('message.success.asnCreation'))
          this.isAsnDialogOpen = false
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
          // this.getVendorShipmentsPending()
        })
    },
    cutText (text, length) {
      return cutText(text, length)
    },
    confirmShipmentCancel (confirm) {
      this.isCancelShipmentConfirmationDialogOpen = false
      if (confirm) {
        this.cancelShipment()
      }
    },
    cancelShipment () {
      this.changeLoadingStatus(true)
      this.$proxy.delete(`api/edi/shipments/${this.shipmentSelected.shipmentId}`)
        .then((r) => {
          this.getVendorShipmentsPending()
          this.showMessage(this.$t('message.success.shipmentCanceled'))
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    openShipmentBlockedDialog (item) {
      this.shipmentSelected = Object.assign({}, item)
      this.isShipmentBlockedDialogOpen = true
    }
  },
  mounted () {
    this.getFacilities()
  },
  watch: {
    options: {
      handler () {
        const { page, itemsPerPage } = this.options
        this.filter.page = page
        this.filter.itemsPerPage = itemsPerPage
        this.getVendorShipmentsPending()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .hidden {
    display: none;
  }
</style>
